import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'app/appStore';
import { setModalIsOpened } from 'features/ConnectSource';

export const useConnectSourceSlice = () => {
	const dispatch = useDispatch();

	return {
		...useSelector((s: RootState) => s.connectSourceSlice),
		setModalIsOpened: (isOpened: boolean) => dispatch(setModalIsOpened(isOpened)),
	};
};
